'use client';

import { useTranslations } from 'next-intl';
import { memo, useCallback } from 'react';
import { Button } from '@//components/Button';
import { useAuth } from '@//providers/AuthProvider';
import { useMarketMetadata } from '@//providers/MarketSettingsProvider';
import styles from '../../../../../components/Header/Header.module.scss';

const UnauthenticatedButtons = () => {
  const { signIn } = useAuth();
  const marketMetadata = useMarketMetadata();
  const t = useTranslations('other.header');

  const onSignIn = useCallback(() => signIn(), [signIn]);

  return (
    <>
      <Button
        variant="secondary"
        sizeLtMd="md"
        sizeMd="lg"
        onClick={onSignIn}
        title={t('signUpButton.title', {
          marketName: marketMetadata.brandName,
        })}
        data-testid="header-button-sign-up"
        className={styles.createAccountButton}
      >
        {t('signUpButton.label')}
      </Button>
      <Button
        variant="cta"
        sizeLtMd="md"
        sizeMd="lg"
        onClick={onSignIn}
        title={t('signInButton.title', {
          marketName: marketMetadata.brandName,
        })}
        data-testid="header-button-sign-in"
      >
        {t('signInButton.label')}
      </Button>
    </>
  );
};

export default memo(UnauthenticatedButtons);
